import { Injectable, signal, Signal } from '@angular/core';
import FileSaver from 'file-saver';
import { BehaviorSubject, catchError, throwError } from 'rxjs';
import { ApiServiceService } from '../../../services/api-service.service';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ClaimedPointOfferService {

    public RefreshWallet: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    
    constructor(private apiService: ApiServiceService) { }

    ClaimOfferOrPoint(model: any) {
        return this.apiService.post(`${environment.apiUrl}/vendor-admin/confirm-points-or-offers`, model)
        // .pipe(catchError(this.handleError));
    }

    handleError(error: any) {
        return throwError(error);
    }

}